import React from 'react';
import '../../../static/styles/apiguide.scss';
import '../../../static/styles/dashboard.scss';

export default class TicketBuyerInfoLookUp extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return(
            <div>
                <h3 className="mb0 mt40">티켓 구매자 정보 조회 API</h3>
                <div className="blog-post-meta">
                    <span className="s-post">티켓 구매자 정보를 조회합니다. 최대 1년 이내의 구매자 정보를 일주일 단위로 조회할 수 있습니다.</span>
                    <h3 className="request-method">
                        <span className="label label-primary">GET</span>
                    </h3>
                </div>
                <div className="table-responsive">
                    <table className="table table-striped">
                        <tbody>
                        <tr>
                            <td>Path</td>
                            <td>Example Endpoint</td>
                        </tr>
                        <tr>
                            <td>
                                /v2/providers/travel_backbone_api/apis/ticket-api/v1/purchasers?searchStartDateTime={'{searchStartDateTime}'}&searchEndDateTime={'{searchEndDateTime}'}&dealId={'{dealId}'}&offset={'{offset}'}&limit={'{limit}'}</td>
                            <td>
                                https://api-gateway.coupang.com/v2/providers/travel_backbone_api/apis/ticket-api/v1/purchasers?searchStartDateTime=20170804000000&searchEndDateTime=20170804235959&dealId=3000000001&offset=0&limit=1000
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>

                <div className="table-responsive mt40">
                    <h4>Request Parameters</h4>
                    <table className="table table-striped">
                        <tbody>
                        <tr>
                            <th colSpan="4" className="bold">Query String Parameter</th>
                        </tr>
                        <tr>
                            <th>Name</th>
                            <th>Required</th>
                            <th>Type</th>
                            <th>Description</th>
                        </tr>
                        <tr>
                            <td>dealId</td>
                            <td>X</td>
                            <td>Long</td>
                            <td>딜번호</td>
                        </tr>
                        <tr>
                            <td>offset</td>
                            <td>O</td>
                            <td>Integer</td>
                            <td>페이지 번호 (첫번째 페이지 = 0)</td>
                        </tr>
                        <tr>
                            <td>limit</td>
                            <td>O</td>
                            <td>Integer</td>
                            <td>최대 요청 갯수 (최댓값 = 1000)</td>
                        </tr>
                        <tr>
                            <td>searchStartDateTime</td>
                            <td>O</td>
                            <td>String</td>
                            <td>구매완료 검색시작일 (yyyyMMddHHmmss)</td>
                        </tr>
                        <tr>
                            <td>searchEndDateTime</td>
                            <td>O</td>
                            <td>String</td>
                            <td>구매완료 검색종료일 (yyyyMMddHHmmss) - 시작일로부터 1주일이내</td>
                        </tr>
                        </tbody>
                    </table>
                </div>

                <div className="table-responsive mt40">
                    <h4>Response Specifications</h4>
                    <table className="table table-striped">
                        <tbody>
                        <tr>
                            <th>Name</th>
                            <th>Type</th>
                            <th>Description</th>
                        </tr>
                        <tr>
                            <td>ticketNumber</td>
                            <td>String</td>
                            <td>티켓번호</td>
                        </tr>
                        <tr>
                            <td>userName</td>
                            <td>String</td>
                            <td>구매자 이름</td>
                        </tr>
                        <tr>
                            <td>phoneNumber</td>
                            <td>String</td>
                            <td>구매자 핸드폰 번호 (010-xxxx-xxxx)</td>
                        </tr>
                        <tr>
                            <td>email</td>
                            <td>String</td>
                            <td>구매자 email</td>
                        </tr>
                        <tr>
                            <td>dealId</td>
                            <td>Long</td>
                            <td>딜 번호</td>
                        </tr>
                        <tr>
                            <td>dealName</td>
                            <td>String</td>
                            <td>딜 명</td>
                        </tr>
                        <tr>
                            <td>optionId</td>
                            <td>Long</td>
                            <td>옵션번호</td>
                        </tr>
                        <tr>
                            <td>optionName</td>
                            <td>String</td>
                            <td>옵션명</td>
                        </tr>
                        <tr>
                            <td>purchaseDateTime</td>
                            <td>Date</td>
                            <td>구매완료일 (yyyy-MM-dd HH:mm:ss)</td>
                        </tr>
                        <tr>
                            <td>price</td>
                            <td>String</td>
                            <td>구매가격</td>
                        </tr>
                        <tr>
                            <td>status</td>
                            <td>String</td>
                            <td>CANCEL_COMPLETE(취소완료), PURCHASE_COMPLETE(구매완료)</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
                <div className="table-responsive mt40">
                    <div className="panel panel-default">
                        <div className="panel-heading">
                            <h3 className="panel-title">응답값 예시</h3>
                        </div>
                        <div className="panel-body">
                    <pre className="ty01">
                        {`
        {
            "totalCount": 2,
            "totalPageCount": 1,
            "countPerPage": 1000,
            "currentPage": 0,
            "ticketPurchasers": [
                {
                    "ticketNumber": "9C320B-9000000000234",
                    "userName": "김쿠팡",
                    "phoneNumber": null,
                    "email": "coupang@coupang.com",
                    "dealId": 6500124641,
                    "dealName": "쿠팡과 함께 바로셀로나",
                    "optionId": 53000424227,
                    "optionName": "즉시 가기  ",
                    "price": "1,000",
                    "purchaseDateTime": "2017-07-05 05:17:13",
                    "status": "PURCHASE_COMPLETE"
                },
                {
                    "ticketNumber": "DCAA6C-9000000000235",
                    "userName": "김쿠팡",
                    "phoneNumber": null,
                    "email": "coupang@coupang.com",
                    "dealId": 6500124641,
                    "dealName": "쿠팡과 함께 바로셀로나",
                    "optionId": 53000424227,
                    "optionName": "즉시 가기  ",
                    "price": "1,000",
                    "purchaseDateTime": "2017-07-05 05:17:13",
                    "status": "PURCHASE_COMPLETE"
                }
            ]
        }
                        `}

                    </pre>
                        </div>
                    </div>
                </div>

                <div className="table-responsive">
                    <table className="table table-striped">
                        <tbody>
                        <tr>
                            <th>error</th>
                            <th>message</th>
                            <th>HTTP CODE</th>
                        </tr>
                        <tr>
                            <td>DATE_FORMATTER_ERROR_MESSAGE</td>
                            <td>yyyyMMddHHmmss 형태로 요청해주시기 바랍니다.</td>
                            <td>400</td>
                        </tr>
                        <tr>
                            <td>DATE_PERIOD_EXCEEDED</td>
                            <td>최대 31일까지 데이터 요청 가능합니다.</td>
                            <td>400</td>
                        </tr>
                        <tr>
                            <td>ILLEGAL_VENDOR_IDS</td>
                            <td>해당되는 accessId에 맵핑된 vendorId가 존재하지 않습니다.</td>
                            <td>400</td>
                        </tr>
                        <tr>
                            <td>INTERNAL_SERVER_ERROR</td>
                            <td>Internal server error.</td>
                            <td>400</td>
                        </tr>
                        <tr>
                            <td>LOWER_BOUND_ERROR</td>
                            <td>검색조건을 양수값으로 요청해주시기 바랍니다.</td>
                            <td>400</td>
                        </tr>
                        <tr>
                            <td>REQUEST_LIMIT_EXCEEDED</td>
                            <td>최대 1000개까지 데이터 요청 가능합니다.</td>
                            <td>400</td>
                        </tr>
                        <tr>
                            <td>RESULT_NOT_FOUND</td>
                            <td>해당되는 검색조건에 맞는 데이터가 존재하지 않습니다.</td>
                            <td>400</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./travel-developers-interface/src/main/client/apis/TicketAPIContent/TicketManagementAPI/TicketBuyerInfoLookup.jsx